import { createAsyncThunk } from "@reduxjs/toolkit";
import { headers, headerConfiguration } from "../../store/auth/headerConfig";
import api from "../../store/api/api";
import { toast } from "react-toastify";

// PTD stands for PrivateTeamDiscussion
export const postPTD = createAsyncThunk(
    "projects/postPTD",
    async ({eid, author, text, parent, media}, {getState, dispatch}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/projects/comments/team-private/${eid}/`
            const formData = new FormData();
            formData.append('text', text);
            formData.append('author', author);
            formData.append('parent', parent);

            // Append each media file
            if (media && media.length > 0) {
                media.forEach((file) => {
                    formData.append('media', file);
                });
            }

            const headerConfig = headerConfiguration(getState, headers, true);
            delete headerConfig['Content-Type'];

            const response = await api(url, "POST", headerConfig, formData, dispatch)
            return response;

        } catch (error) {
            console.error(error);
            toast.dismiss()
            toast.error(error?.message || 'Failed to create comment');
            return error;
        }
    }
)


export const getAllPTDByProjectID = createAsyncThunk(
    "projects/getAllPTDByProjectID",
    async ({eid}, {getState, dispatch}) => {

        const headerConfig = headerConfiguration(getState, headers)

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/projects/comments/team-private/${eid}/`

            const response = await api(url, "GET", headerConfig, null, dispatch);
            return response
            

        } catch (error) {
      // console.error(error)
        return (error?.message)
        }
    }
)

export const fetchRepliesToEachPTD = createAsyncThunk(
    "projects/fetchRepliesToEachPTD",
    async ({comment_eid},{dispatch, getState}) => {

        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/projects/team-private/comment/replies/${comment_eid}/`

            const headerConfig = headerConfiguration(getState, headers)
            const response = await api(url, "GET", headerConfig, null, dispatch)
            return response

        } catch (error) {
            console.log(error)
            return error
        }
    }
)



// DELETE COMMENTS API
export const deleteOnePTD = createAsyncThunk(
    "projects/deleteOnePTD",
    async ({comment_eid}, {getState, dispatch}) => {

        const headerConfig = headerConfiguration(getState, headers)

        try {
            const url =  `${process.env.REACT_APP_SERVER_URL}/api/projects/comments/team-private/${comment_eid}/`
            const response = await api(url, "DELETE", headerConfig, null, dispatch);
            return response

        } catch (error) {
      // console.error(error)
      return (error?.message);
        }
    }
)


// UPDATE COMMENTS API
export const updateOnePTD = createAsyncThunk(
    "projects/updateOnePTD",
    async ({comment_eid, edited_comment}, {getState, dispatch}) => {

        const headerConfig = headerConfiguration(getState, headers)
        try {
            const url = `${process.env.REACT_APP_SERVER_URL}/api/projects/comments/team-private/${comment_eid}/`
            const body = { text: edited_comment}
            const response = await api(url, "PATCH", headerConfig, body, dispatch);
            return response

        } catch (error) {
      // console.error(error)
      return (error?.message);
        }
    }
)


export const getPTDReactionActivity = createAsyncThunk(
    "projects/getPTDReactionActivity",
    async ({user_id, project_id, comment_id},{dispatch, getState}) => {

        const headerConfig = headerConfiguration(getState, headers)
        try {
          const url = `${process.env.REACT_APP_SERVER_URL}/api/projects/team-private/comment/${user_id}/reaction/${project_id}/${comment_id}/`
          const response = await api(url, "GET", headerConfig, null, dispatch);
          return response
        } catch (error) {
          // console.error(error)
          return (error?.message);
        }
    }
)


export const reactToPTDReactionActivity = createAsyncThunk(
  'projects/reactToPTDReactionActivity',
  async({user_id, project_id, vote_type,comment_id},{dispatch, getState}) => {

    const headerConfig = headerConfiguration(getState, headers)

    try {
      const url =  `${process.env.REACT_APP_SERVER_URL}/api/projects/team-private/comment/${user_id}/reaction/${project_id}/${comment_id}/`
      const body = {
            vote_type
        }
        const response = await api(url, "POST", headerConfig, body, dispatch)
        // console.log("response", response)
        return response;
        }catch(error){
        // console.error(error)
        return (error?.message);
        }
  }
)
